import { Accordion, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
const DetailTemplateSection = ({ title, children }: any) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Accordion
      variant="separated"
      value={isOpen ? title : null}
      radius={10}
      mb={15}
      mx={10}
      transitionDuration={300}
      className="case-detail-template-section"
      classNames={{ chevron: "chevron" }}
      onChange={(value) => {
        setIsOpen(value === title);
      }}
      chevron={<IconChevronDown color="white" width={20} height={20} />}
    >
      <Accordion.Item key={title} value={title}>
        <Accordion.Control bg={"rgb(0, 53, 84)"} className="header-section" style={
            isOpen
              ? { borderTopLeftRadius: 10, borderTopRightRadius: 10 }
              : { borderRadius: 10 }
          }>
          <Text fz={16} fw={500} c={"white"}>
            {title}
          </Text>
        </Accordion.Control>
        <Accordion.Panel className="case-detail-template-section_content">
          {children}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
export default DetailTemplateSection;
